import { ResponsePayload } from "@/types/model";
import { get, getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getProjects = async (
  token: string,
  baseUrl: string,
  params: any,
  config?: any
) => {
  const queryPath = `${baseUrl}/projects`;
  try {
    const res = await get(token, queryPath, params, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const getProject = async (
  token: string,
  baseUrl: string,
  projectId: string,
  params?: object,
  config?: object
) => {
  const queryPath = `${baseUrl}/projects/${projectId}`;
  return await getData(token, queryPath, params, config).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};
